import React from 'react';
import { TrendingUp, Download } from 'lucide-react';
import { generatePDF } from './utils/pdfGenerator';
import type { ScenarioResult } from '../../types';

interface HeaderProps {
  results: ScenarioResult;
  chartRef: React.RefObject<any>;
}

export function Header({ results, chartRef }: HeaderProps) {
  const handleDownload = () => {
    generatePDF(chartRef, results);
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-2">
        <TrendingUp className="h-5 w-5 text-blue-600" />
        <h2 className="text-lg font-semibold text-gray-900">Investment Analysis Dashboard</h2>
      </div>
      <button
        onClick={handleDownload}
        className="flex items-center gap-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200 ease-in-out shadow-sm"
      >
        <Download className="h-4 w-4" />
        Download PDF Report
      </button>
    </div>
  );
}